/**
 * @generated SignedSource<<998238542f61cbdd69016ce29c691dff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type StorecastHeader_store$data = {
  readonly currentEmployee: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderProfileButton_employee">;
  } | null;
  readonly dashboards: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"StorecastPickerButton_dasbhoards">;
  }>;
  readonly me: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderProfileButton_storeUser">;
  } | null;
  readonly myRole: Roles;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastAdminButton_Store">;
  readonly " $fragmentType": "StorecastHeader_store";
};
export type StorecastHeader_store$key = {
  readonly " $data"?: StorecastHeader_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastHeader_store">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "employeeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastHeader_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "myRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dashboard",
      "kind": "LinkedField",
      "name": "dashboards",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StorecastPickerButton_dasbhoards"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "employeeId"
        }
      ],
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "currentEmployee",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamHeaderProfileButton_employee"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreUser",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamHeaderProfileButton_storeUser"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastAdminButton_Store"
    }
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "c3870d2643760a8e70c28c15945d3e2d";

export default node;
